export type BrandAssetFormat = 'svg' | 'png' | 'jpg' | 'webp' | 'gif' | 'mp4' | 'webm' | 'mov' | 'm4v';

export type BrandAssetType = 'icon' | 'logo' | 'video';

export type CardBackgroundMode = 'light' | 'dark' | 'checkerboard';

export const BRAND_ASSET_UPLOAD_FOLDERS = [
  { prefix: 'shout-agency', label: 'SHOUT Agency' },
  { prefix: 'shout-main', label: 'SHOUT Main' },
  { prefix: 'shout-plus', label: 'SHOUT+' },
  { prefix: 'shout-studio', label: 'SHOUT Studio' },
  { prefix: 'socials', label: 'Socials' },
  { prefix: 'affiliate', label: 'Affiliate' },
  { prefix: 'other', label: 'Other' },
] as const;

export type BrandAssetUploadFolder = (typeof BRAND_ASSET_UPLOAD_FOLDERS)[number]['prefix'];

export interface BrandAsset {
  brand: string;
  asset: BrandAssetType | string;
  variant: string;
  size: string;
  format: BrandAssetFormat | string;
  key: string;
  url: string;
}

export interface BrandAssetTab {
  id: string;
  label: string;
  assets: BrandAsset[];
}

export interface BrandAssetLibrary {
  bucket: string;
  region: string;
  tabs: BrandAssetTab[];
}

export interface BrandAssetGroup {
  assetType: string;
  assets: BrandAsset[];
}
